import { authenticatedUserSelector } from '@geekbears/gb-ngrx-auth-basic';
import { AppUser } from '@modules/company-manager/users/domain';
import { Store, createSelector } from '@ngrx/store';
import { isNil } from 'lodash';
import { filter, map } from 'rxjs';

export const appAuthenticatedUserSelector = createSelector(
  authenticatedUserSelector,
  (state) => {
    return state as AppUser | null;
  }
);

export const appUserCompanyNameSelector = createSelector(
  appAuthenticatedUserSelector,
  (user) => {
    return user?.company?.companyName;
  }
);

export const ensureAppUserSelector = (store: Store) => {
  return store.select(appAuthenticatedUserSelector).pipe(
    filter((user) => {
      return !isNil(user);
    }),
    map((user) => {
      return user!;
    })
  );
};
